import { Component } from '@angular/core';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PaypalService } from '../../../services/paypal.service';

@Component({
    selector: 'app-paypal-plan',
    imports: [RouterModule, FormsModule],
    templateUrl: './create-plan.component.html',
    styleUrl: './create-plan.component.css'
})
export class CreatePlanComponent {
  product = { name: '', description: '' };
  plan = { price: '', billing: 'MONTH', currency: 'USD' };
  currencySymbols: any = {
    USD: '$',
    EUR: '€'
  };

  createdProductId: string | null = null;
  createdPlanId: string | null = null;
  subscriptionURL: string | null = null;

  loading = false;
  planCreated = false;
  statusMessage = '';

  constructor(private paypalService: PaypalService) { }

  async createSubscriptionFlow() {
    try {
      this.loading = true;
      this.planCreated = false;
      this.subscriptionURL = null;
      this.statusMessage = 'Creating Plan...';

      // 1️⃣ Create Product
      const productRes: any = await this.paypalService.createProduct({
        name: this.product.name,
        description: this.product.description,
        type: 'SERVICE',
        category: 'SOFTWARE',
      });
      this.createdProductId = productRes.id;

      this.statusMessage =
        'Product created successfully — now creating the pricing plan...';

      // 2️⃣ Create Plan
      const planRes: any = await this.paypalService.createPlan({
        product_id: this.createdProductId,
        name: `${this.product.name} Subscription`,
        billing_cycles: [
          {
            frequency: {
              interval_unit: this.plan.billing,
              interval_count: 1,
            },
            tenure_type: 'REGULAR',
            sequence: 1,
            total_cycles: 0,
            pricing_scheme: {
              fixed_price: {
                value: this.plan.price.toString(),
                currency_code: this.plan.currency,
              },
            },
          },
        ],
        payment_preferences: {
          auto_bill_outstanding: true,
          payment_failure_threshold: 3,
        },
      });

      this.createdPlanId = planRes.id;

      this.statusMessage = 'Plan created — creating plan...';

      // 3️⃣ Create Subscription
      const subRes: any = await this.paypalService.createSubscription(
        this.createdPlanId!
      );

      this.subscriptionURL = subRes.links.find(
        (l: any) => l.rel === 'approve'
      )?.href;

      this.planCreated = true;
      this.statusMessage =
        'Subscription ready — click Start to pay with PayPal';
    } catch (err: any) {
      console.error('PayPal Error:', err);
      console.error('Details:', err?.error);
      this.statusMessage =
        'Error: ' + (err?.error?.message || 'Check console for details');
    } finally {
      this.loading = false;
    }
  }

  startSubscription() {
    if (this.subscriptionURL) {
      window.open(this.subscriptionURL, '_blank');
    }
  }
}
